<div class="min-h-screen flex items-center justify-center p-6" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);">
  <div class="bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-md p-10">
    <div class="text-center mb-6">
      <div class="flex justify-center mb-4 px-24">
        <img src="/Logo.png" alt="Logo" class="w-full h-auto object-contain">
      </div>
      <div class="flex justify-center mb-4">
        <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
          <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
          </svg>
        </div>
      </div>
      <h1 class="text-3xl font-semibold text-gray-800 mb-2 m-0">Account Frozen</h1>
      <p class="text-base text-gray-500 m-0">Your account has been frozen by an administrator</p>
    </div>

    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-start">
        <svg class="w-5 h-5 text-red-600 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
        </svg>
        <div>
          <h3 class="text-lg font-medium text-red-800 mb-2">Access Restricted</h3>
          <p class="text-sm text-red-700">
            Your account has been temporarily frozen by a system administrator.
            Please contact your system administrator to regain access to your account.
          </p>
        </div>
      </div>
    </div>

    <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <div class="flex items-start">
        <svg class="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <div>
          <h3 class="text-lg font-medium text-blue-800 mb-2">Next Steps</h3>
          <ul class="text-sm text-blue-700 space-y-1">
            <li>• Contact your system administrator</li>
            <li>• Request account reactivation</li>
            <li>• Wait for administrator approval</li>
          </ul>
        </div>
      </div>
    </div>

      </div>
</div>